<template>
  <div class="collection-container">
    <Filter></Filter>
    <List></List>
  </div>
  <ActivityModal></ActivityModal>
</template>

<script>
import List from './components/List.vue'
import Filter from './components/Filter.vue'
import ActivityModal from './components/ActivityModal.vue'
import {
  queryPageActivities,
  savePageActivities,
  genUrlPageActivities,
  detailPageActivities
} from '../../../server/modules/share'
import { toRefs, reactive, provide, onMounted, nextTick } from 'vue'
import { common_querySiteInfo_get } from '@/server/modules/3426.js'
import dayjs from 'dayjs'
import { message } from 'ant-design-vue'
export default {
  components: {
    Filter,
    List,
    ActivityModal
  },
  setup() {
    const state = reactive({
      brands: [],
      channels: [],
      sites: [],
      terminals: [],
      searchParams: {
        siteId: 1,
        channelId: 1,
        brandId: 1
        // terminalId: 1
      },
      pagination: {
        current: 1, //默认的当前页数
        pageSize: 10, //每页显示几条数据
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        onChange: (current, pageSize) => {
          state.pagination.current = current
          state.pagination.pageSize = pageSize
          state.getTabList()
        },
        onShowSizeChange: (current, pageSize) => {
          state.pagination.current = current
          state.pagination.pageSize = pageSize
          state.getTabList()
        }
      },
      //表格数据
      dataSource: [],
      oldDataSource: [],
      //列
      columns: [
        {
          title: '序号',
          dataIndex: 'activityId',
          key: 'activityId',
          align: 'center'
        },
        {
          title: '品牌',
          dataIndex: 'brandName',
          key: 'brandName',
          align: 'center'
        },
        {
          title: '渠道',
          dataIndex: 'channelName',
          key: 'channelName',
          align: 'center'
        },
        {
          title: '站点',
          dataIndex: 'siteName',
          key: 'siteName',
          align: 'center'
        },
        {
          title: '终端',
          dataIndex: 'terminalName',
          key: 'terminalName',
          align: 'center'
        },
        {
          title: '活动有效期',
          align: 'center',
          dataIndex: 'time'
        },
        {
          title: '编辑人',
          dataIndex: 'updateUser',
          key: 'updateUser',
          align: 'center'
        },
        {
          title: '编辑时间',
          dataIndex: 'lastUpdateTime',
          key: 'lastUpdateTime',
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          align: 'center'
        },
        // {
        //   title: '中心入口',
        //   dataIndex: 'entranceStatus',
        //   key: 'entranceStatus',
        //   width: 120
        // },
        {
          title: '操作',
          dataIndex: 'operate',
          align: 'center'
        }
      ],
      unitOps: {
        1: '分钟',
        2: '小时',
        3: '天'
      },
      bodyStyle: {
        height: '750px',
        overflow: 'hidden',
        overflowY: 'scroll'
      },
      async queryData() {
        try {
          const { success, data } = await common_querySiteInfo_get()
          if (success) {
            state.brands = data[1].map(e => ({
              label: e.name,
              value: e.id
            }))
            // state.brands.unshift({ label: '全部', value: '' })
            state.channels = data[2].map(e => ({
              label: e.name,
              value: e.id
            }))
            // state.channels.unshift({ label: '全部', value: '' })
            state.sites = data[3].map(e => ({
              label: e.name,
              value: e.id
            }))
            // state.sites.unshift({ label: '全部', value: '' })
            state.terminals = data[4].map(e => ({
              label: e.name,
              value: e.id
            }))
            // state.terminals.unshift({ label: '全部', value: '' })
          }
        } catch (error) {
          console.log('error', error)
        }
      },
      //筛选
      filterData: {
        brandId: 1,
        channelId: 1,
        siteId: 1,
        terminalId: 1
      },
      //
      initList: () => {
        state.getTabList()
      },
      //重置筛选
      resetFilter: () => {
        state.filterData = {
          brandId: 1,
          channelId: 1,
          siteId: 1,
          terminalId: 1
        }
        state.initList()
      },
      //
      getSearchList: () => {
        state.pagination.current = 1
        state.getTabList()
      },
      //table数据
      getTabList: () => {
        const param = {
          query: { ...state.filterData },
          // ...state.pagination,
          pageSize: state.pagination.pageSize,
          pageNum: state.pagination.current
        }
        queryPageActivities(param)
          .then(e => {
            if (e.success) {
              // state.dataSource = e.data.list
              state.pagination.total = e.data.total
              state.oldDataSource = e.data.list
              state.getOldDataSource()
            }
          })
          .catch(err => {
            console.log('err: ', err)
          })
      },
      async getOldDataSource() {
        try {
          const { success, data } = await common_querySiteInfo_get()
          if (success) {
            for (let i = 0; i < state.oldDataSource.length; i++) {
              for (let h = 0; h < data[1].length; h++) {
                if (state.oldDataSource[i].brandId === data[1][h].id) {
                  state.oldDataSource[i].brandName = data[1][h].name
                  break
                }
              }
              for (let j = 0; j < data[2].length; j++) {
                if (state.oldDataSource[i].channelId === data[2][j].id) {
                  state.oldDataSource[i].channelName = data[2][j].name
                  break
                }
              }
              for (let k = 0; k < data[3].length; k++) {
                if (state.oldDataSource[i].siteId === data[3][k].id) {
                  state.oldDataSource[i].siteName = data[3][k].name
                  break
                }
              }
              for (let l = 0; l < data[4].length; l++) {
                if (state.oldDataSource[i].terminalId === data[4][l].id) {
                  state.oldDataSource[i].terminalName = data[4][l].name
                  break
                }
              }
            }
            // alert(JSON.stringify(state.oldDataSource))
            state.dataSource = state.oldDataSource
          }
        } catch (error) {
          console.log('error', error)
        }
      },
      modalVisible: false,
      //添加参数
      activityParams: {
        activityId: '',
        brandId: '',
        channelId: '',
        siteId: '',
        terminalId: '',
        helperNum: 0,
        shareNum: 0,
        helpNum: 0,
        shareLinkEffectTime: '',
        shareLinkEffectTimeUnit: 0,
        activityEffectStartTime: '',
        activityEffectEndTime: '',
        sharerCouponRuleId: '',
        sharerCouponStartTime: '',
        sharerCouponEndTime: '',
        helperCouponRuleId: '',
        helperCouponStartTime: '',
        helperCouponEndTime: '',
        sharerSuccessUrl: '',
        helperLandUrl: '',
        helperSuccessUrl: '',
        activityExpireUrl: '',
        entranceStatus: 1,
        shareLinkEffectTimeUnitName: 1,
        timeSet: [],
        timeSetTwo: [],
        timeSetThree: [],
        sharerRewardType: 1,
        sharerPointRuleId: null,
        helperRewardType: 1,
        helperPointRuleId: null
      },
      conditionsList: [
        {
          label: '条件名称',
          value: '下单数'
        },
        {
          label: '操作符',
          value: '等于'
        },
        {
          label: '条件值',
          value: ''
        },
        {
          label: '关联券规则',
          value: ''
        },
        {
          label: '券有效日期',
          value: ''
        }
      ],
      //校验
      activityRules: {
        // brandId: [{ required: true, message: '请选择品牌！' }],
        // channelId: [{ required: true, message: '请选择渠道！' }],
        // siteId: [{ required: true, message: '请选择站点！' }],
        // terminalId: [{ required: true, message: '请选择终端！' }],
        shareLinkEffectTimeUnit: [
          {
            required: true,
            message: '请选择分享连接有效期！'
          }
        ],
        timeSet: [{ required: true, message: '请输入活动有效期！' }],
        timeSetTwo: [{ required: true, message: '请输入券有效期！' }],
        timeSetThree: [{ required: true, message: '请输入券有效期！' }],
        helperCouponRuleId: [{ required: true, message: '请输入券规则ID！' }],
        helperPointRuleId: [{ required: true, message: '请输入积分ID！' }],
        sharerPointRuleId: [{ required: true, message: '请输入积分ID！' }],
        sharerCouponRuleId: [{ required: true, message: '请输入券规则ID！' }],
        sharerSuccessUrl: [
          { required: true, message: '请输入分享者领取成功弹窗shop now按钮！' }
        ],
        helperLandUrl: [
          {
            required: true,
            message: '请输入助力者落地页面！'
          }
        ],
        activityExpireUrl: [
          { required: true, message: '请输入活动结束弹窗shop now按钮！' }
        ],
        helperSuccessUrl: [
          { required: true, message: '请输入助力者助力成功弹窗shop now按钮！' }
        ]
      },
      //0新增 1编辑 2详情
      modalType: 0,
      //添加
      addActive: (type, info) => {
        state.resetActivityParams()
        if (info) {
          state.getDetail(info)
        }
        state.modalType = type
        state.modalVisible = true
        nextTick(() => {
          state.activityRef.clearValidate()
        })
      },
      async getDetail(record) {
        const params = {
          activityId: record.activityId
        }
        detailPageActivities(params)
          .then(e => {
            if (e.success) {
              state.activityParams = {
                ...e.data,
                timeSet: [
                  dayjs(e.data.activityEffectStartTime),
                  dayjs(e.data.activityEffectEndTime)
                ],
                timeSetTwo: [
                  dayjs(e.data.sharerCouponStartTime),
                  dayjs(e.data.sharerCouponEndTime)
                ],
                timeSetThree: [
                  dayjs(e.data.helperCouponStartTime),
                  dayjs(e.data.helperCouponEndTime)
                ]
              }
              if (e.data.shareLinkEffectTimeUnit !== 0) {
                state.activityParams.shareLinkEffectTimeUnit = 1
                state.activityParams.shareLinkEffectTimeUnitName =
                  e.data.shareLinkEffectTimeUnit
              } else {
                state.activityParams.shareLinkEffectTime = ''
                state.activityParams.shareLinkEffectTimeUnitName = 1
              }
              // alert(JSON.stringify(state.activityParams))
            }
          })
          .catch(err => {
            console.log('err: ', err)
          })
      },
      selectType() {
        if (state.activityParams.shareLinkEffectTimeUnit === 0) {
          state.activityParams.shareLinkEffectTime = ''
          state.activityParams.shareLinkEffectTimeUnitName = 1
          console.log(state.activityParams.shareLinkEffectTime)
        }
      },
      changeDate() {
        console.log(state.activityParams.shareLinkEffectTime)
      },
      //重置数据
      resetActivityParams: () => {
        state.activityParams = {
          activityId: '',
          brandId: '',
          channelId: '',
          siteId: '',
          terminalId: '',
          helperNum: 0,
          shareNum: 0,
          helpNum: 0,
          shareLinkEffectTime: '',
          shareLinkEffectTimeUnit: 0,
          activityEffectStartTime: '',
          activityEffectEndTime: '',
          sharerCouponRuleId: '',
          sharerCouponStartTime: '',
          sharerCouponEndTime: '',
          helperCouponRuleId: '',
          helperCouponStartTime: '',
          helperCouponEndTime: '',
          sharerSuccessUrl: '',
          helperLandUrl: '',
          helperSuccessUrl: '',
          activityExpireUrl: '',
          entranceStatus: 1,
          shareLinkEffectTimeUnitName: 1,
          timeSet: [],
          timeSetTwo: [],
          timeSetThree: [],
          sharerRewardType: 1,
          sharerPointRuleId: null,
          helperRewardType: 1,
          helperPointRuleId: null
        }
      },
      activityRef: null,
      modalCancel: () => {
        state.modalVisible = false
      },
      //
      addRow() {
        if (state.activityParams.helperNum < 5) {
          state.activityParams.helperNum++
        }
        return state.activityParams.helperNum
      },
      delRow() {
        return state.activityParams.helperNum === 0
          ? 0
          : state.activityParams.helperNum--
      },
      addRowTwo() {
        return state.activityParams.shareNum++
      },
      delRowTwo() {
        return state.activityParams.shareNum === 0
          ? 0
          : state.activityParams.shareNum--
      },
      addRowThree() {
        return state.activityParams.helpNum++
      },
      delRowThree() {
        return state.activityParams.helpNum === 0
          ? 0
          : state.activityParams.helpNum--
      },
      transformNum: value => {
        let v = null
        switch (typeof value) {
          case 'string':
            v = isNaN(+value) ? 1 : value.replace(/\./g, '')
            break
          case 'number':
            v = isNaN(value) ? 1 : String(value).replace(/\./g, '')
            break
          default:
            v = 1
        }
        return v
      },
      //
      copyFun(text) {
        const cInput = document.createElement('input')
        cInput.value = text
        document.body.appendChild(cInput)
        cInput.select() // 选取文本域内容;
        document.execCommand('Copy')
        message.success('复制成功!')
        cInput.remove()
      },
      async generateLink(record) {
        const params = {
          activityId: record.activityId
        }
        genUrlPageActivities(params)
          .then(e => {
            if (e.success) {
              state.copyFun(e.data)
            }
          })
          .catch(err => {
            console.log('err: ', err)
          })
      },
      //
      modalSubmit: async () => {
        if (state.modalType !== 2) {
          state.activityRef
            .validateFields()
            .then(() => {
              // alert(JSON.stringify(state.activityParams))
              const param = {}
              if (state.activityParams.activityId !== '') {
                param.activityId = state.activityParams.activityId
              }
              param.brandId = state.filterData.brandId
              param.channelId = state.filterData.channelId
              param.siteId = state.filterData.siteId
              param.terminalId = state.filterData.terminalId
              param.helperNum = state.activityParams.helperNum
              param.shareNum = state.activityParams.shareNum
              param.helpNum = state.activityParams.helpNum
              if (state.activityParams.shareLinkEffectTimeUnit === 0) {
                param.shareLinkEffectTimeUnit =
                  state.activityParams.shareLinkEffectTimeUnit
                param.shareLinkEffectTime = 0
              } else {
                param.shareLinkEffectTimeUnit =
                  state.activityParams.shareLinkEffectTimeUnitName
                param.shareLinkEffectTime =
                  state.activityParams.shareLinkEffectTime
              }
              param.activityEffectStartTime =
                state.activityParams.activityEffectStartTime
              param.activityEffectEndTime =
                state.activityParams.activityEffectEndTime
              param.sharerCouponRuleId = state.activityParams.sharerCouponRuleId
              param.sharerCouponStartTime =
                state.activityParams.sharerCouponStartTime
              param.sharerCouponEndTime =
                state.activityParams.sharerCouponEndTime
              param.helperCouponRuleId = state.activityParams.helperCouponRuleId
              param.helperCouponStartTime =
                state.activityParams.helperCouponStartTime
              param.helperCouponEndTime =
                state.activityParams.helperCouponEndTime
              param.sharerSuccessUrl = state.activityParams.sharerSuccessUrl
              param.helperLandUrl = state.activityParams.helperLandUrl
              param.helperSuccessUrl = state.activityParams.helperSuccessUrl
              param.activityExpireUrl = state.activityParams.activityExpireUrl
              param.entranceStatus = state.activityParams.entranceStatus
              param.helperRewardType = state.activityParams.helperRewardType
              param.sharerRewardType = state.activityParams.sharerRewardType
              param.sharerPointRuleId = state.activityParams.sharerPointRuleId
              param.helperPointRuleId = state.activityParams.helperPointRuleId
              // alert(JSON.stringify(param))
              savePageActivities(param)
                .then(e => {
                  if (e.success) {
                    state.modalVisible = false
                    state.getTabList()
                  } else {
                    message.warning(e.retInfo)
                  }
                })
                .catch(e => {
                  console.log('e: ', e)
                  message.warning(e.retInfo)
                })
            })
            .catch(e => {
              console.log('e: ', e)
            })
        } else {
          state.modalVisible = false
        }
      },
      //时间
      timeChange: e => {
        state.activityParams.activityEffectStartTime =
          e === null || e.length === 0
            ? null
            : e[0].format('YYYY-MM-DD HH:mm:ss')
        state.activityParams.activityEffectEndTime =
          e === null || e.length === 0
            ? null
            : e[1].format('YYYY-MM-DD HH:mm:ss')
      },
      timeChangeTwo: e => {
        state.activityParams.sharerCouponStartTime =
          e === null || e.length === 0
            ? null
            : e[0].format('YYYY-MM-DD 00:00:00')
        state.activityParams.sharerCouponEndTime =
          e === null || e.length === 0
            ? null
            : e[1].format('YYYY-MM-DD 00:00:00')
      },
      timeChangeThree: e => {
        state.activityParams.helperCouponStartTime =
          e === null || e.length === 0
            ? null
            : e[0].format('YYYY-MM-DD 00:00:00')
        state.activityParams.helperCouponEndTime =
          e === null || e.length === 0
            ? null
            : e[1].format('YYYY-MM-DD 00:00:00')
      },
      handleOpenEntry: async (targetVal, record) => {
        // const targetVal = e.target.value
        const params = {
          activityId: record.id,
          entranceStatus: targetVal
        }
        let { success, retInfo } = savePageActivities(params)
        if (success) {
          record.entranceStatus = targetVal
        } else {
          message.error(retInfo)
        }
      },
      //img
      imageType: {
        type: 'pc',
        tip: 'PC端(三倍图) 360 * 360',
        width: 360,
        height: 360,
        size: 500
      },
      //获取图片地址
      setImgUrl: url => {
        state.activityParams.icon = url
        state.activityRef.clearValidate(['icon'])
      },
      //删除图片
      delActivityImg: () => {
        state.activityParams.icon = ''
      },
      //校验
      formRules: (r, v) => {
        if (!v) {
          return Promise.reject(new Error('不能为空'))
        } else {
          return Promise.resolve()
        }
      },
      //更新状态
      updateStatus: info => {
        const param = {
          id: info.id,
          status: info.status === 2 ? 1 : 2
        }
        savePageActivities(param)
          .then(e => {
            if (e.success) {
              state.getTabList()
            } else {
              message.warning(e.retInfo)
            }
          })
          .catch(err => {
            console.log('err: ', err)
          })
      }
    })
    onMounted(() => {
      state.queryData()
      state.getSearchList()
      state.initList()
    })
    provide('initState', state)
    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}
</style>
